import { __extends } from "tslib";
import { Group } from '@antv/g';
import { visibility } from './visibility';
var OffscreenGroup = /** @class */ (function (_super) {
    __extends(OffscreenGroup, _super);
    function OffscreenGroup() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    // a offscreen can only have one child
    OffscreenGroup.prototype.appendChild = function (child, index) {
        this.destroyChildren();
        visibility(child, false);
        return _super.prototype.appendChild.call(this, child, index);
    };
    return OffscreenGroup;
}(Group));
export function createOffscreenGroup(container) {
    var group = container.appendChild(new OffscreenGroup({
        style: { visibility: 'hidden' },
    }));
    visibility(group, false);
    return group;
}
//# sourceMappingURL=offscreen.js.map